// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getSessionUserEmail } from '../config/common';
import { toast } from 'react-toastify';
import { isEmptyObject, isSystemFeedItem, sanitizeCommentBody } from '../utils/helpers';
import { useAppDispatch } from '../hooks';
import * as caseRequiredListAction from '../Action/Case_Required_List/Case_Required_List_Action';
import * as caseListAction from '../Action/Case_List/Case_List_Action';
import * as caseCommentsListAction from '../Action/Case_Comments_List/Case_Comments_List_Action';
import * as caseCommentsAddAction from '../Action/Case_Comments_Add/Case_Comments_Add_Action';
import * as caseCommentsAddReplyAction from '../Action/Case_Comments_Add_Reply/Case_Comments_Add_Reply_Action';
import * as caseUploadFileAction from '../Action/Case_Upload_File/Case_Upload_File_Action';
import * as caseCreateAction from '../Action/Case_Create/Case_Create_Action';
import * as caseCloseAction from '../Action/Case_Close/Case_Close_Action';
import Loader from './Loader';
import FilePreviewModal, { shouldOpenFileInPreviewModal } from './FilePreviewModal';
import FeedBody, { useRecordFileCache } from './FeedBody';
import FeedAttachments from './FeedAttachments';
import { FILE_MESSAGES, openRecordAttachment } from '../utils/recordFiles';
import dayjs from 'dayjs';
import DOMPurify from "dompurify";

const isClosedWithin30Days = (ticket) => {
    if (ticket.Status !== 'Closed' || !ticket.ClosedDate) return false;
    const closedDate = dayjs(ticket.ClosedDate);
    return dayjs().diff(closedDate, 'day') <= 30;
};

const canInteract = (ticket) => {
    return ticket.allowUpdate && (ticket.Status !== 'Closed' || isClosedWithin30Days(ticket));
};

function commentInitials(name) {
    if (!name || typeof name !== 'string') return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const TicketTab = ({ id, navKey, tab, onNavigate, onCloseDetail }) => {
    const dispatch = useAppDispatch();
    const [data, setData] = useState({
        priorityList: [],
        statusList: [],
        userEmail: getSessionUserEmail()
    });
    const [caseList, setCaseList] = useState([]);
    const [ticketModal, setTicketModal] = useState(false);
    const [filePreviewModal, setFilePreviewModal] = useState(false);
    const [viewTicketModal, setViewTicketModal] = useState(false);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        totalPage: 1,
        pageSize: 10
    });
    const [ticketDetails, setTicketDetails] = useState({});
    const [ticketCommentList, setTicketCommentList] = useState([]);
    const [filterParam, setFilterParam] = useState({
        ticketNo: '',
        seletedStatus: '',
        sortType: 'Recent',
        searchText: '',
        priority: '',
        hideClosed: false,
        incApproved: false
    });
    /** Start true so the full-screen loader shows on first paint when parent skips its own loader (Support page). */
    const [isLoading, setIsLoading] = useState(true);
    const hasFetched = useRef();
    const [caseCreateForm, setCaseCreateForm] = useState({
        subject: '',
        description: ''
    });
    const [isCreateCaseModalShow, setIsCreateCaseModalShow] = useState(false);
    const [isCloseCaseModalShow, setIsCloseCaseModalShow] = useState(false);
    const [closeCaseStepsTaken, setCloseCaseStepsTaken] = useState('');
    const [isClosingCase, setIsClosingCase] = useState(false);
    const chatterSortRef = useRef(null);
    const fileUploadRef = useRef(null);
    /* ACOP-123: the open ticket's inline images and attachment preview, revoked on close/switch/unmount. */
    const { imageCache, cacheVersion: imageCacheVersion, onImagesSettled } = useRecordFileCache(ticketDetails.Id);
    const previewFileModalRef = useRef(null);
    const openAttachmentRef = useRef(null);

    useEffect(() => {
        if(hasFetched.current) return;
        hasFetched.current = true;

        getRequiredData(getCaseList);
        initCaseCreateForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        if (!hasFetched.current || !id) return;
        setIsLoading(true);
        setTicketCommentList([]);
        const param = { email: getSessionUserEmail(), id };
        dispatch(caseListAction.case_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status !== 1) { setIsLoading(false); toast.error(response.message); return; }
            if (!response.data.caseList || response.data.caseList.length === 0) {
                toast.error('Unauthorized: You do not have access to this support ticket.');
                onCloseDetail && onCloseDetail();
                loadCaseListPage(1);
                return;
            }
            setIsLoading(false);
            response.data.caseList.forEach(item => {
                setCaseList([item]);
                setTicketDetails(item);
                setIsLoading(true);
                getCommentsList(item.Id);
            });
            setViewTicketModal(true);
            setTicketModal(true);
        }).catch(error => { setIsLoading(false); toast.error(error.message); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, navKey]);

    const initCaseCreateForm = () => {
        setCaseCreateForm({
            subject: '',
            description: ''
        });
    };

    const getRequiredData = async (callback) => {
        var param = {};
        param.email = getSessionUserEmail();
        dispatch(caseRequiredListAction.case_required_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status === 1) {
                setData({...data, priorityList: response.data.casePriorityList || [], statusList: response.data.caseStatusList || []});
            }
            if (callback) {
                callback(pagination.pageNo);
            } else {
                setIsLoading(false);
            }
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const getCaseList = async (pageNo, filter = filterParam) => {
        // eslint-disable-next-line no-unused-vars
        let ticketViewModal = false;
        if (id && !viewTicketModal && tab === 'ticket') {
            var param = {}
            param.email = getSessionUserEmail();
            param.id = id || null;
            dispatch(caseListAction.case_list({ data: JSON.stringify(param) })).then((response) => {
                setIsLoading(false);
                if (response.status !== 1) {
                    toast.error(response.message);
                    return;
                }
                if (!response.data.caseList || response.data.caseList.length === 0) {
                    toast.error('Unauthorized: You do not have access to this support ticket.');
                    onCloseDetail && onCloseDetail();
                    loadCaseListPage(pageNo, filter);
                    return;
                }
                response.data.caseList.forEach(item => {
                    setCaseList([item]);
                    setTicketDetails(item);
                    setIsLoading(true);
                    getCommentsList(item.Id);
                    ticketViewModal = true;
                })
                setViewTicketModal(true);
                setTicketModal(true);
                if (response.data.totalPage) {
                    setPagination((prev) => ({
                        ...prev,
                        totalPage: response.data.totalPage
                    }))
                }
            }).catch(error => {
                toast.error(error.message);
            })
        } else {
            loadCaseListPage(pageNo, filter);
        }
    };

    const loadCaseListPage = (pageNo, filter = filterParam) => {
        let param = { ...filter };
        param.pageSize = pagination.pageSize;
        param.pageNo = pageNo;
        param.searchText = encodeURIComponent(param.searchText);
        param.email = getSessionUserEmail();
        dispatch(caseListAction.case_list({ data: JSON.stringify(param) })).then((response) => {
            setIsLoading(false);
            if (response.status !== 1) {
                toast.error(response.message);
                return;
            }
            setCaseList(response.data.caseList);
            if (response.data.totalPage) {
                setPagination((prev) => ({
                    ...prev,
                    totalPage: response.data.totalPage
                }))
            }
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const handleInputChange = (e) => {
        setFilterParam({...filterParam, [e.target.name]: e.target.value, incApproved: true});
    }

    const handleHideClosedChange = (e) => {
        setFilterParam({ ...filterParam, hideClosed: e.target.checked, incApproved: true });
    };

    const onApplyFilter = () => {
        setIsLoading(true);
        setPagination((prev) => ({
            ...prev,
            pageNo: 1
        }));
        getCaseList(1);
    };

    const clearFilter = () => {
        setIsLoading(true);
        let filter = {
            ticketNo: '',
            seletedStatus: '',
            sortType: 'Recent',
            searchText: '',
            priority: '',
            hideClosed: false,
            incApproved: false
        };
        setFilterParam(filter);
        getCaseList(1, filter);
        setIsLoading(true);
    };

    const changePage = (pageNo) => {
        setPagination((prev) => ({
            ...prev,
            pageNo: pageNo
        }));
        getCaseList(pageNo);
        setIsLoading(true);
    };

    const getCommentsList = async (ticketId, value = 'Most Recent Activity') => {
        var param = {};
        param.email = getSessionUserEmail();
        param.sortType = value;
        param.caseId = ticketId;
        dispatch(caseCommentsListAction.case_comments_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status === 1) {
                setTicketCommentList(response.data);
            }
            setIsLoading(false);
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const addReply = async(e) => {
        e.preventDefault();
        let replyId = e.target.replyId.value;
        let reply = e.target.reply.value;
        let params = {
            email: getSessionUserEmail(),
            commentId: replyId,
            reply: reply
        };
        setIsLoading(true);
        dispatch(caseCommentsAddReplyAction.case_comments_add_reply({ data: JSON.stringify(params) })).then((response) => {
            if (response.status !== 1) {
                setIsLoading(false);
                toast.error(response.message);
                return;
            }
            getCommentsList(ticketDetails.Id, chatterSortRef.current?.value || 'Most Recent Activity');
            e.target.reply.value = '';
        }).catch(error => {
            console.log(error);
            toast.error(error.message);
        })
    }

    const sortComments = (e) => {
        let value = e.target.value;
        setIsLoading(true);
        getCommentsList(ticketDetails.Id, value);
    }

    /* TICKET MODAL */
    function openModal(item) {
        setTicketDetails(item);
        setTicketModal(true);
        setIsLoading(true);
        getCommentsList(item.Id);
    }

    function closeModal(resetRoute = true) {
        setTicketDetails({});
        setTicketCommentList([]);
        setTicketModal(false);
        setIsCloseCaseModalShow(false);
        setCloseCaseStepsTaken('');
        if (resetRoute) {
            onCloseDetail && onCloseDetail();
        }
    }

    const showCloseCaseModal = () => {
        setCloseCaseStepsTaken('');
        setIsCloseCaseModalShow(true);
    };

    const hideCloseCaseModal = () => {
        if (isClosingCase) return;
        setIsCloseCaseModalShow(false);
        setCloseCaseStepsTaken('');
    };

    const submitCloseCase = async () => {
        const stepsTaken = closeCaseStepsTaken.trim();
        if (!stepsTaken) {
            toast.error('Please describe the steps taken to solution.');
            return;
        }
        if (!ticketDetails?.Id) {
            toast.error('Missing case identifier.');
            return;
        }
        const params = {
            email: getSessionUserEmail(),
            caseId: ticketDetails.Id,
            stepsTaken: stepsTaken
        };
        setIsClosingCase(true);
        dispatch(caseCloseAction.case_close({ data: JSON.stringify(params) })).then((response) => {
            setIsClosingCase(false);
            if (response.status !== 1) {
                toast.error(response.message || 'Unable to close case.');
                return;
            }
            toast.success('Case closed.');
            setIsCloseCaseModalShow(false);
            setCloseCaseStepsTaken('');
            // Refresh both the open detail (badge, composer state) and the list (so a
            // Closed-status filter picks the case up immediately).
            const closedTicket = { ...ticketDetails, Status: 'Closed', ClosedDate: new Date().toISOString() };
            setTicketDetails(closedTicket);
            setCaseList((prev) => prev.map((t) => (t.Id === closedTicket.Id ? closedTicket : t)));
            getCommentsList(closedTicket.Id, chatterSortRef.current?.value || 'Most Recent Activity');
        }).catch((error) => {
            setIsClosingCase(false);
            console.log(error);
            toast.error(error?.message || 'Unable to close case.');
        });
    };

    const postNewComment = async(e) => {
        e.preventDefault();
        let caseId = e.target.commentId.value;
        let comment = e.target.chatterNewPost.value;
        let params = {
            email: getSessionUserEmail(),
            caseId: caseId,
            comment: comment
        };
        setIsLoading(true);
        dispatch(caseCommentsAddAction.case_comments_add({ data: JSON.stringify(params) })).then((response) => {
            if (response.status !== 1) {
                setIsLoading(false);
                toast.error(response.message);
                return;
            }
            getCommentsList(caseId, chatterSortRef.current?.value || 'Most Recent Activity');
            e.target.chatterNewPost.value = '';
        }).catch(error => {
            console.log(error);
            toast.error(error.message);
        })
    }

    const handleFileUpload = async (e) => {
        if (!fileUploadRef.current || fileUploadRef.current.files.length === 0) {
            toast.error('Please select file to upload');
            return;
        }
        const file = fileUploadRef.current.files[0];

        if (file.size > 2097152) {
            toast.error('File size should not exceed 2MB');
            return;
        }

        setIsLoading(true);

        const reader = new FileReader();
        reader.onload = () => {
            let params = {
                email: getSessionUserEmail(),
                caseId: ticketDetails.Id,
                fileName: file.name.replace(/[^a-zA-Z0-9 ._-]/g, '')
            };
            let base64File = reader.result.split('base64,')[1];

            dispatch(caseUploadFileAction.case_upload_file(params, base64File)).then((response) => {
                setIsLoading(false);
                if (response.status !== 1) {
                    toast.error(response.message);
                    return;
                }
                if (fileUploadRef.current) {
                    fileUploadRef.current.value = '';
                }
                ticketDetails.fileList.push(response.data);
            }).catch(error => {
                console.log(error);
                toast.error(error.message);
            })
        };
        reader.readAsDataURL(file);
    };

    const showCreateCase = () => {
        setIsCreateCaseModalShow(true);
    };

    const createCase = () => {
        var param = caseCreateForm;
        if (!param.subject) {
            toast.error("Please enter ticket subject.");
            return;
        }
        if (!param.description) {
            toast.error("Please enter ticket description.");
            return;
        }
        param.email = getSessionUserEmail();
        setIsLoading(true);
        dispatch(caseCreateAction.case_create({ data: JSON.stringify(param) })).then((response) => {
            if (response.status !== 1) {
                setIsLoading(false);
                toast.error(response.message);
                return;
            }
            toast.success("Ticket submitted successfully.");
            hideCreateCase();
            setCaseList([response.data].concat(caseList));
            setTicketDetails(response.data);
            setIsLoading(true);
            getCommentsList(response.data.Id);
            setViewTicketModal(true);
            setTicketModal(true);
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const hideCreateCase = () => {
        setIsCreateCaseModalShow(false);
        setCaseCreateForm({...caseCreateForm, subject: '', description: ''});
    };

    const handleCaseInputChange = (e) => {
        setCaseCreateForm({...caseCreateForm, [e.target.name]: e.target.value});
    }

    /* Click-to-zoom on a feed image (FeedBody passes the loaded src). Stable, so memoised bodies skip unrelated re-renders. */
    const handleCommentImageClick = useCallback((src, name) => {
        previewFileModalRef.current(src, name, 'image');
    }, []);

    /* ACOP-123: a file attached to a post or reply opens exactly as its Attachments entry does. Stable, like the image click above. */
    const handleFeedAttachmentOpen = useCallback((file) => {
        openAttachmentRef.current(file);
    }, []);

    function openCaseAttachment(item) {
        const name = item.name || item.Name || '';
        if (!item.docId) {
            // Release window (D8): until the Salesforce half ships, list items still carry filePublicUrl.
            openLegacyAttachment(item.filePublicUrl, name);
            return;
        }
        openRecordAttachment('case', ticketDetails.Id, item, { cache: imageCache, onPreview: previewFileModal, onBusy: setIsLoading });
    }
    openAttachmentRef.current = openCaseAttachment;

    function openLegacyAttachment(fileUrl, name) {
        if (!fileUrl) {
            toast.error(FILE_MESSAGES.unavailable);
            return;
        }
        if (shouldOpenFileInPreviewModal(name, fileUrl)) {
            previewFileModal(fileUrl, name);
        } else {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        }
    }

    /* File Preview Modal (images + PDF only). `kind` is set for proxy blob: URLs, which carry no extension. */
    function previewFileModal(fileUrl, fileName, kind) {
        setData((prev) => ({ ...prev, curFileUrl: fileUrl, curFileName: fileName || '', curFileKind: kind }));
        setFilePreviewModal(true);
        setTicketModal(false);
    }
    previewFileModalRef.current = previewFileModal;

    function closeFilePreviewModal() {
        setFilePreviewModal(false);
        setTicketModal(true);
    }

    return (
        <>
            { isLoading && <Loader /> }

            {/* Tickets Section */}
            <div id="ticketsContainer" className="copilot-filter-layout">
                {/* Filters */}
                <aside className="copilot-filter-rail">
                    <button className="btn btn-primary btn-sm mb-2 w-100" type='button' onClick={() => showCreateCase()}>
                        Submit New Ticket
                    </button>
                    <h2 className="copilot-filter-rail__title">Filter by</h2>

                    <label className="form-label">Ticket Number</label>
                    <input type="text" className="form-control mb-3" value={filterParam.ticketNo} name='ticketNo' placeholder="Enter Ticket Number" onChange={(e) => handleInputChange(e)} />

                    <label className="form-label">Status</label>
                    <select className="form-select mb-3" name='seletedStatus' value={filterParam.seletedStatus} onChange={(e) => handleInputChange(e)}>
                        <option value={''}>All Status</option>
                        {
                            data.statusList && data.statusList.map((item, index) => (
                                <option value={item.value} key={index}>{item.label}</option>
                            ))
                        }
                    </select>

                    <label className="form-label">Priority</label>
                    <select className="form-select mb-3" name='priority' value={filterParam.priority} onChange={(e) => handleInputChange(e)}>
                        <option value={''}>All Priority</option>
                        {
                            data.priorityList && data.priorityList.map((item, index) => (
                                <option value={item.value} key={index}>{item.label}</option>
                            ))
                        }
                    </select>

                    <label className="form-label">Sort By</label>
                    <select className="form-select mb-3" name='sortType' value={filterParam.sortType} onChange={(e) => handleInputChange(e)}>
                        <option value="Recent">Newest Opened</option>
                        <option value="RecentlyUpdated">Recently Updated</option>
                        <option value="ticketNumber">Ticket Number</option>
                    </select>

                    <label className="form-label">Keyword</label>
                    <input type="text" className="form-control mb-3" placeholder="Search..." name='searchText' value={filterParam.searchText} onChange={(e) => handleInputChange(e)} />

                    <div className="mb-3">
                        <input className="form-check-input" type="checkbox" name="hideClosed" id="hideClosedItems" checked={filterParam.hideClosed} onChange={(e) => handleHideClosedChange(e)} />
                        <label className="form-check-label ps-1" htmlFor="hideClosedItems">Hide Closed Items</label>
                    </div>

                    {
                        filterParam.incApproved ? (
                            <button className="btn btn-primary w-100 mb-3" type="button" onClick={() => clearFilter()}>Clear</button>
                        ) : ''
                    }

                    <button className="btn btn-primary w-100" type='button' onClick={() => onApplyFilter()}>
                        Apply
                    </button>
                </aside>

                {/* Tickets List */}
                <main className="flex-grow-1 min-w-0 ms-lg-4 mt-3 mt-lg-0">

                    {
                        pagination.totalPage > 1 && (
                            <div className="row px-2 mb-2" >
                                <div className="col-12 background py-2 text-end">
                                    <button className="btn btn-primary me-2 shrink" onClick={() => changePage(pagination.pageNo - 1)} disabled={pagination.pageNo === 1}>Previous</button>
                                    {pagination.pageNo}&nbsp;/&nbsp;{pagination.totalPage}
                                    <button className="btn btn-primary ms-2 shrink" onClick={() => changePage(pagination.pageNo + 1)} disabled={pagination.pageNo >= pagination.totalPage}>Next</button>
                                </div>
                            </div>
                        )
                    }

                    {
                        caseList.length === 0 ?
                            <div className='text-center'>
                                <h6>No Data Available</h6>
                            </div>
                        :
                            caseList.map((item, index) => (
                                <div
                                    key={index}
                                    className="copilot-changelog-card copilot-support-list-card mb-3 cursor-pointer"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => openModal(item)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            openModal(item);
                                        }
                                    }}
                                >
                                    <div
                                        className="copilot-changelog-card__accent copilot-changelog-card__accent--muted"
                                        aria-hidden
                                    />
                                    <div className="copilot-changelog-card__body">
                                        <h3 className="copilot-changelog-section-title text-primary mb-2">{item.CaseNumber}</h3>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="text-muted small mb-1">Owner: {item['Owner.Name']}</p>
                                                <p className="text-muted small mb-1">Contact: {item['Contact.Name']}</p>
                                                <p className="text-muted small mb-1">Date/Time Modified: {dayjs(item.LastModifiedDate).format('YYYY-MM-DD hh:mm A')}</p>
                                                {
                                                    item.Change_Request__c && <p className="text-muted small mb-1">CR ID: <button type="button" className="btn btn-link p-0 text-primary text-decoration-none" onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate('changeRequest', item['Change_Request__c']); }}>{item['Change_Request__r.Name']}</button></p>
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <p className="text-muted small mb-1">Status: {item.Status}</p>
                                                <p className="text-muted small mb-1">Priority: {item.Priority}</p>
                                                <p className="text-muted small mb-1">Date/Time Opened: {dayjs(item.CreatedDate).format('YYYY-MM-DD hh:mm A')}</p>
                                            </div>
                                        </div>
                                        <p className="my-2 small text-body mb-0">{item.Subject}</p>
                                    </div>
                                </div>
                            ))
                    }

                    {
                        pagination.totalPage > 1 && (
                            <div className="row px-2 mb-2" >
                                <div className="col-12 background py-2 text-end">
                                    <button className="btn btn-primary me-2 shrink" onClick={() => changePage(pagination.pageNo - 1)} disabled={pagination.pageNo === 1}>Previous</button>
                                    {pagination.pageNo}&nbsp;/&nbsp;{pagination.totalPage}
                                    <button className="btn btn-primary ms-2 shrink" onClick={() => changePage(pagination.pageNo + 1)} disabled={pagination.pageNo >= pagination.totalPage}>Next</button>
                                </div>
                            </div>
                        )
                    }
                </main>
            </div>

            {/* Ticket detail — Change Log / upgrade modal design family */}
            { ticketModal && <>
                <div
                    id="ticketModal"
                    className="modal fade show copilot-ticket-detail-modal-root"
                    tabIndex="-1"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modalTitle"
                    style={{ display: 'block' }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable px-2 min-w-0" role="document" style={{ maxWidth: 'min(960px, calc(100vw - 1.5rem))' }}>
                        <div className="modal-content copilot-ticket-detail-modal d-flex flex-column" style={{ maxHeight: 'min(90vh, 880px)' }}>
                            <div className="copilot-ticket-detail-modal__accent" aria-hidden />
                            {
                                isEmptyObject(ticketDetails) ? (
                                    <>
                                        <div className="modal-header border-0 copilot-ticket-detail-modal__header pb-0">
                                            <h2 id="modalTitle" className="copilot-changelog-section-title mb-0">No ticket available</h2>
                                            <button type="button" className="btn-close" aria-label="Close" onClick={() => closeModal()} />
                                        </div>
                                        <div className="modal-body copilot-ticket-detail-modal__body pt-2">
                                            <p className="text-body-secondary small mb-0">We could not load this case. It may have been removed or you may not have access.</p>
                                        </div>
                                        <div className="modal-footer border-0 copilot-ticket-detail-modal__footer gap-2">
                                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => closeModal()}>Close</button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="modal-header border-0 copilot-ticket-detail-modal__header">
                                            <div className="flex-grow-1 min-w-0 pe-2">
                                                <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                                    <h2 id="modalTitle" className="copilot-changelog-section-title mb-0 text-truncate">
                                                        {ticketDetails.CaseNumber}
                                                    </h2>
                                                    <span className={`badge rounded-pill ${ticketDetails.Status === 'Closed' ? 'text-bg-secondary' : 'text-bg-primary'}`}>
                                                        {ticketDetails.Status}
                                                    </span>
                                                    {ticketDetails.Priority && (
                                                        <span className="badge rounded-pill bg-body-secondary text-body border">
                                                            {ticketDetails.Priority}
                                                        </span>
                                                    )}
                                                </div>
                                                <p className="text-body-secondary small mb-0 text-truncate" title={ticketDetails.Subject}>
                                                    {ticketDetails.Subject}
                                                </p>
                                            </div>
                                            <button type="button" className="btn-close flex-shrink-0" aria-label="Close" onClick={() => closeModal()} />
                                        </div>

                                        <div className="modal-body flex-grow-1 overflow-auto min-h-0 copilot-ticket-detail-modal__body pt-0">
                                            <div className="copilot-ticket-detail-meta bg-body-tertiary border rounded-3 p-3 mb-3">
                                                <div className="row g-2 g-md-3 small">
                                                    <div className="col-12 col-md-6">
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Owner</span>
                                                            <span className="text-body">{ticketDetails['Owner.Name']}</span>
                                                        </div>
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Contact</span>
                                                            <span className="text-body">{ticketDetails['Contact.Name']}</span>
                                                        </div>
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Last modified</span>
                                                            <span className="text-body">{dayjs(ticketDetails.LastModifiedDate).format('YYYY-MM-DD h:mm A')}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        {ticketDetails.Change_Request__c && (
                                                            <div className="copilot-ticket-detail-meta__row">
                                                                <span className="copilot-ticket-detail-meta__label">Change request</span>
                                                                <span>
                                                                    <button type="button" className="btn btn-link btn-sm p-0 text-start" onClick={() => { closeModal(false); onNavigate && onNavigate('changeRequest', ticketDetails['Change_Request__c']); }}>
                                                                        {ticketDetails['Change_Request__r.Name']}
                                                                    </button>
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Opened</span>
                                                            <span className="text-body">{dayjs(ticketDetails.CreatedDate).format('YYYY-MM-DD h:mm A')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <section className="mb-3">
                                                <h3 className="copilot-changelog-detail-section-title">Case summary</h3>
                                                <div className="copilot-ticket-detail-summary">
                                                    <div className="copilot-ticket-detail-form-field">
                                                        <label className="copilot-ticket-detail-form-label" htmlFor="ticket-detail-subject-readonly">Subject</label>
                                                        <div id="ticket-detail-subject-readonly" className="copilot-ticket-detail-form-readonly">
                                                            {ticketDetails.Subject}
                                                        </div>
                                                    </div>
                                                    <div className="copilot-ticket-detail-form-field copilot-ticket-detail-form-field--spaced">
                                                        <span className="copilot-ticket-detail-form-label">Description</span>
                                                        <div className="copilot-ticket-detail-description copilot-ticket-detail-form-textarea-mirror" style={{ whiteSpace: "pre-wrap", lineHeight: "1.5", maxHeight: "min(40vh, 320px)", overflowY: "auto" }}>
                                                            {ticketDetails.Description && /<[a-z][\s\S]*>/i.test(ticketDetails.Description) ? (
                                                                <span style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ticketDetails.Description) }} />
                                                            ) : (
                                                                <span className="text-body">{ticketDetails.Description || 'No description available'}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>

                                            <section className="mb-3">
                                                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                                    <h3 className="copilot-changelog-detail-section-title mb-0">Attachments</h3>
                                                </div>
                                                {canInteract(ticketDetails) && (
                                                    <div className="copilot-ticket-detail-upload mb-3">
                                                        <div className="d-flex flex-wrap align-items-stretch gap-2">
                                                            <div className="flex-grow-1 min-w-0" style={{ minWidth: '12rem' }}>
                                                                <label className="copilot-ticket-detail-form-label" htmlFor="fileUpload">Add a file</label>
                                                                <input type="file" ref={fileUploadRef} id="fileUpload" className="form-control form-control-sm rounded-3" accept="*"/>
                                                            </div>
                                                            <div className="d-flex align-items-end">
                                                                <button type="button" className="btn btn-sm btn-primary rounded-3 px-3" onClick={handleFileUpload}>
                                                                    <i className="fa-solid fa-cloud-arrow-up me-1" aria-hidden />
                                                                    Upload
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-2 copilot-file-attachment-row">
                                                    {
                                                        !ticketDetails.fileList || ticketDetails.fileList.length === 0 ? (
                                                            <div className="col-12">
                                                                <p className="text-body-secondary small mb-0">No files attached.</p>
                                                            </div>
                                                        ) : (
                                                            ticketDetails.fileList.map((item, index) => (
                                                                <div className="col min-w-0" key={index}>
                                                                    <div className="border rounded-3 p-3 text-center copilot-file-attachment-card copilot-ticket-detail-file-card h-100 d-flex flex-column">
                                                                        <i className="fa-solid fa-file-lines fa-2x text-body-secondary mb-2" aria-hidden />
                                                                        <p className="small text-primary mb-1 text-break">
                                                                            <span role="button" tabIndex={0} className="d-inline-block text-decoration-underline" style={{ maxWidth: '100%' }} data-testid="ticket-attachment-open" data-doc-id={item.docId || undefined} onKeyDown={(e) => e.key === 'Enter' && openCaseAttachment(item)} onClick={() => openCaseAttachment(item)}>
                                                                                {item.name || item.Name}
                                                                            </span>
                                                                        </p>
                                                                        <p className="text-body-secondary small mb-0 mt-auto">Added {dayjs(item.date).format('MMM D, YYYY')}</p>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        )
                                                    }
                                                </div>
                                            </section>

                                            <section className="pt-2 mt-1 border-top border-secondary-subtle copilot-ticket-detail-activity">
                                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                                    <h3 className="copilot-changelog-detail-section-title mb-0">Conversation</h3>
                                                    <div className="d-flex align-items-center gap-2 copilot-ticket-detail-sort">
                                                        <label className="text-body-secondary small mb-0 text-nowrap" htmlFor="chatterSort">Sort</label>
                                                        <select ref={chatterSortRef} id="chatterSort" className="form-select form-select-sm copilot-ticket-detail-sort__select" onChange={(e) => sortComments(e)} aria-label="Sort comments">
                                                            <option value="Most Recent Activity">Newest first</option>
                                                            <option value="Oldest First">Oldest first</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                {canInteract(ticketDetails) ? (
                                                    <div className="copilot-ticket-detail-composer mb-4">
                                                        {isClosedWithin30Days(ticketDetails) && (
                                                            <div className="alert alert-info py-2 px-3 small mb-2 mb-md-3 rounded-3">
                                                                This ticket is closed. Posting a comment will reopen it.
                                                            </div>
                                                        )}
                                                        <form onSubmit={postNewComment} className="copilot-ticket-detail-composer__form">
                                                            <label className="copilot-ticket-detail-form-label" htmlFor="chatterNewPost">Share an update</label>
                                                            <textarea
                                                                id="chatterNewPost"
                                                                name="chatterNewPost"
                                                                rows="4"
                                                                className="form-control copilot-ticket-detail-composer__textarea"
                                                                placeholder="Write a comment for the support team…"
                                                            />
                                                            <input type="hidden" name="commentId" value={ticketDetails.Id} />
                                                            <div className="copilot-ticket-detail-composer__footer">
                                                                <button type="submit" className="btn btn-sm btn-primary rounded-3 px-4">
                                                                    <i className="fa-solid fa-paper-plane me-1" aria-hidden />
                                                                    Post
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                ) : ticketDetails.Status === 'Closed' ? (
                                                    <div className="alert alert-warning small rounded-3 mb-4 py-3" role="status">
                                                        This ticket has been closed for more than 30 days and no longer accepts comments. Please open a new ticket.
                                                    </div>
                                                ) : (
                                                    <div className="alert alert-primary small rounded-3 mb-4 py-3" role="status">
                                                        This ticket is older than 6 months so comments are blocked. If you are having an issue please open a new ticket.
                                                    </div>
                                                )}

                                                <div id="commentsContainer" className="copilot-ticket-detail-comment-list d-flex flex-column gap-3">
                                                    {ticketCommentList && ticketCommentList.map((item, index) => (
                                                        <article className={`copilot-ticket-detail-comment${isSystemFeedItem(item.Type) ? ' copilot-ticket-detail-comment--system' : ''}`} key={item.Id || index}>
                                                            <div className="copilot-ticket-detail-comment__inner">
                                                                <div className="copilot-ticket-detail-comment__header">
                                                                    <span className="copilot-ticket-detail-avatar" aria-hidden>
                                                                        {commentInitials(item['CreatedBy.Name'])}
                                                                    </span>
                                                                    <div className="copilot-ticket-detail-comment__meta min-w-0">
                                                                        <div className="fw-semibold text-body text-truncate" title={item['CreatedBy.Name']}>
                                                                            {item['CreatedBy.Name']}
                                                                            {isSystemFeedItem(item.Type) && (
                                                                                <span className="badge text-bg-light border ms-2 fw-normal">Update</span>
                                                                            )}
                                                                        </div>
                                                                        <time className="text-body-secondary small" dateTime={item.CreatedDate}>
                                                                            {dayjs(item.CreatedDate).format('MMM D, YYYY · h:mm A')}
                                                                        </time>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={`copilot-ticket-detail-comment__body copilot-comment-body small${isSystemFeedItem(item.Type) ? ' text-body-secondary fst-italic' : ''}`}
                                                                    role="presentation"
                                                                >
                                                                    <FeedBody
                                                                        html={sanitizeCommentBody(item.Body)}
                                                                        imageCache={imageCache}
                                                                        cacheVersion={imageCacheVersion}
                                                                        kind="case"
                                                                        recordId={ticketDetails.Id}
                                                                        onImagesSettled={onImagesSettled}
                                                                        onImageClick={handleCommentImageClick}
                                                                    />
                                                                    <FeedAttachments files={item.attachments} onOpen={handleFeedAttachmentOpen} />
                                                                </div>
                                                            </div>

                                                            {item.comments && item.comments.length > 0 && (
                                                                <div className="copilot-ticket-detail-thread">
                                                                    {item.comments.sort((a, b) => new Date(a.CreatedDate) - new Date(b.CreatedDate)).map((reply, reIndex) => (
                                                                        <div className="copilot-ticket-detail-reply" key={reIndex}>
                                                                            <div className="copilot-ticket-detail-comment__header copilot-ticket-detail-comment__header--reply">
                                                                                <span className="copilot-ticket-detail-avatar copilot-ticket-detail-avatar--sm" aria-hidden>
                                                                                    {commentInitials(reply['CreatedBy.Name'])}
                                                                                </span>
                                                                                <div className="copilot-ticket-detail-comment__meta min-w-0">
                                                                                    <div className="fw-semibold text-body small text-truncate" title={reply['CreatedBy.Name']}>
                                                                                        {reply['CreatedBy.Name']}
                                                                                    </div>
                                                                                    <time className="text-body-secondary" style={{ fontSize: '0.75rem' }} dateTime={reply.CreatedDate}>
                                                                                        {dayjs(reply.CreatedDate).format('MMM D, YYYY · h:mm A')}
                                                                                    </time>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="copilot-ticket-detail-comment__body copilot-comment-body small"
                                                                                role="presentation"
                                                                            >
                                                                                <FeedBody
                                                                                    html={sanitizeCommentBody(reply.CommentBody)}
                                                                                    imageCache={imageCache}
                                                                                    cacheVersion={imageCacheVersion}
                                                                                    kind="case"
                                                                                    recordId={ticketDetails.Id}
                                                                                    onImagesSettled={onImagesSettled}
                                                                                    onImageClick={handleCommentImageClick}
                                                                                />
                                                                                <FeedAttachments files={reply.attachments} onOpen={handleFeedAttachmentOpen} />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {canInteract(ticketDetails) && (
                                                                <form onSubmit={addReply} className="copilot-ticket-detail-reply-form">
                                                                    <input type="hidden" name="replyId" value={item.Id} />
                                                                    <label className="visually-hidden" htmlFor={`reply-${item.Id}`}>Reply to this comment</label>
                                                                    <textarea
                                                                        id={`reply-${item.Id}`}
                                                                        rows="2"
                                                                        name="reply"
                                                                        className="form-control form-control-sm"
                                                                        placeholder="Write a reply…"
                                                                    />
                                                                    <div className="copilot-ticket-detail-reply-form__actions">
                                                                        <button type="submit" className="btn btn-sm btn-outline-primary rounded-3">
                                                                            Send reply
                                                                        </button>
                                                                    </div>
                                                                </form>
                                                            )}
                                                        </article>
                                                    ))}
                                                </div>
                                            </section>
                                        </div>

                                        <div className="modal-footer border-0 copilot-ticket-detail-modal__footer gap-2">
                                            {canInteract(ticketDetails) && ticketDetails.Status !== 'Closed' && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger rounded-3 px-3"
                                                    onClick={showCloseCaseModal}
                                                >
                                                    <i className="fa-solid fa-circle-check me-1" aria-hidden />
                                                    Close Support Case
                                                </button>
                                            )}
                                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => closeModal()}>Close</button>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show copilot-ticket-detail-modal-backdrop" />
            </> }

            <FilePreviewModal
                isOpen={filePreviewModal}
                fileUrl={data.curFileUrl}
                fileName={data.curFileName}
                kind={data.curFileKind}
                onClose={() => closeFilePreviewModal()}
            />

            {/* create case — submit new ticket */}
            {isCreateCaseModalShow && (
                <>
                    <div
                        className="modal fade show copilot-changelog-upgrade-modal-root"
                        id="createCaseModal"
                        role="dialog"
                        aria-labelledby="createCaseModalLabel"
                        aria-modal="true"
                        aria-hidden="false"
                        style={{ display: 'block' }}
                    >
                        <div className="modal-dialog modal-dialog-centered mw-570 px-2" role="document">
                            <div className="modal-content copilot-changelog-upgrade-modal">
                                <div className="copilot-changelog-upgrade-modal__accent" aria-hidden />
                                <div className="modal-header copilot-changelog-upgrade-modal__header border-0">
                                    <div className="flex-grow-1 min-w-0 pe-2">
                                        <h2
                                            className="copilot-changelog-section-title copilot-changelog-upgrade-modal__title"
                                            id="createCaseModalLabel"
                                        >
                                            Submit new ticket
                                        </h2>
                                        <p className="copilot-changelog-section-lead copilot-changelog-upgrade-modal__lead mb-0 mt-1">
                                            Subject and description are required. You can attach files
                                            after the ticket is created.
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close copilot-changelog-upgrade-modal__close flex-shrink-0 mt-0"
                                        aria-label="Close"
                                        onClick={hideCreateCase}
                                    />
                                </div>
                                <div className="modal-body copilot-changelog-upgrade-modal__body">
                                    <form
                                        id="support-new-ticket-form"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            createCase();
                                        }}
                                    >
                                        <div className="copilot-changelog-upgrade-modal__fields">
                                            <div className="row g-2">
                                                <div className="col-12">
                                                    <label
                                                        className="copilot-changelog-upgrade-modal__label"
                                                        htmlFor="support-ticket-subject"
                                                    >
                                                        Subject
                                                    </label>
                                                    <input
                                                        id="support-ticket-subject"
                                                        type="text"
                                                        name="subject"
                                                        className="form-control form-control-sm login-form-control copilot-changelog-upgrade-modal__control rounded-3"
                                                        value={caseCreateForm.subject}
                                                        onChange={handleCaseInputChange}
                                                        placeholder="Short summary"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <label
                                                        className="copilot-changelog-upgrade-modal__label"
                                                        htmlFor="support-ticket-description"
                                                    >
                                                        Description
                                                    </label>
                                                    <textarea
                                                        id="support-ticket-description"
                                                        name="description"
                                                        className="form-control form-control-sm login-form-control copilot-changelog-upgrade-modal__control copilot-changelog-upgrade-modal__textarea rounded-3"
                                                        rows={4}
                                                        value={caseCreateForm.description}
                                                        onChange={handleCaseInputChange}
                                                        placeholder="Describe the issue or question…"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer copilot-changelog-upgrade-modal__footer border-0 gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary login-form-secondary"
                                        onClick={hideCreateCase}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        form="support-new-ticket-form"
                                        className="btn btn-sm btn-primary login-form-submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show copilot-changelog-upgrade-modal-backdrop" />
                </>
            )}

            {/* close case — capture required Steps Taken to Solution before flipping Status to Closed */}
            {isCloseCaseModalShow && (
                <>
                    <div
                        className="modal fade show copilot-changelog-upgrade-modal-root"
                        id="closeCaseModal"
                        role="dialog"
                        aria-labelledby="closeCaseModalLabel"
                        aria-modal="true"
                        aria-hidden="false"
                        style={{ display: 'block' }}
                    >
                        <div className="modal-dialog modal-dialog-centered mw-570 px-2" role="document">
                            <div className="modal-content copilot-changelog-upgrade-modal">
                                <div className="copilot-changelog-upgrade-modal__accent" aria-hidden />
                                <div className="modal-header copilot-changelog-upgrade-modal__header border-0">
                                    <div className="flex-grow-1 min-w-0 pe-2">
                                        <h2
                                            className="copilot-changelog-section-title copilot-changelog-upgrade-modal__title"
                                            id="closeCaseModalLabel"
                                        >
                                            Close support case
                                        </h2>
                                        <p className="copilot-changelog-section-lead copilot-changelog-upgrade-modal__lead mb-0 mt-1">
                                            Describe what was done to resolve this ticket. The text is saved
                                            with the case for the support team's records.
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close copilot-changelog-upgrade-modal__close flex-shrink-0 mt-0"
                                        aria-label="Close"
                                        onClick={hideCloseCaseModal}
                                        disabled={isClosingCase}
                                    />
                                </div>
                                <div className="modal-body copilot-changelog-upgrade-modal__body">
                                    <form
                                        id="support-close-case-form"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            submitCloseCase();
                                        }}
                                    >
                                        <div className="copilot-changelog-upgrade-modal__fields">
                                            <div className="row g-2">
                                                <div className="col-12">
                                                    <label
                                                        className="copilot-changelog-upgrade-modal__label"
                                                        htmlFor="support-close-case-steps"
                                                    >
                                                        Steps taken to solution
                                                    </label>
                                                    <textarea
                                                        id="support-close-case-steps"
                                                        name="stepsTaken"
                                                        className="form-control form-control-sm login-form-control copilot-changelog-upgrade-modal__control copilot-changelog-upgrade-modal__textarea rounded-3"
                                                        rows={6}
                                                        maxLength={32768}
                                                        value={closeCaseStepsTaken}
                                                        onChange={(e) => setCloseCaseStepsTaken(e.target.value)}
                                                        placeholder="What did you do to resolve this issue?"
                                                        autoFocus
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer copilot-changelog-upgrade-modal__footer border-0 gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary login-form-secondary"
                                        onClick={hideCloseCaseModal}
                                        disabled={isClosingCase}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        form="support-close-case-form"
                                        className="btn btn-sm btn-danger"
                                        disabled={isClosingCase || closeCaseStepsTaken.trim().length === 0}
                                    >
                                        {isClosingCase ? 'Closing…' : 'Close case'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show copilot-changelog-upgrade-modal-backdrop" />
                </>
            )}
        </>

    )
}

export default TicketTab;